import { Component, ViewChild } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {EventService} from '../../core/services/event.service';
import { NgForm } from '@angular/forms';
import { FormsComponent } from '../../core/interfaces';
import { UnsavedChangesService } from '../../core/services/unsaved-changes.service';
import { NgbNav } from '@ng-bootstrap/ng-bootstrap';
import { ProgressService } from '../../core/services/progress.service';

@Component({
    selector: 'cat-page',
    templateUrl: './profile.page.html',
    styleUrls: ['./profile.page.scss']
})

export class ProfilePage implements FormsComponent {
    @ViewChild('tabset', { static: true }) tabset: NgbNav;

    public model: any;
    public state: any;
    public forms: NgForm[] = [];
    private isUnsavedChangesTrigerred = false;

    constructor(
        public route: ActivatedRoute,
        public eventService: EventService,
        public unsavedChangesService: UnsavedChangesService,
        public progressService: ProgressService,
    ) {}

    addForm(form) {
        this.forms.push(form);
    }

    onTabChange(event) {
        let hasDirtyForm = false;
        for (const form of this.forms) {
            if (form && form.dirty) {
                hasDirtyForm = true;
                break;
            }
        }
        if (hasDirtyForm && !this.isUnsavedChangesTrigerred) {
            event.preventDefault();
            this.unsavedChangesService.openDialog().then((val) => {
                if (val) {
                    this.tabset.select(event.nextId);
                    this.progressService.stopProgress(false);
                }
                this.isUnsavedChangesTrigerred = false;
                this.forms = [];
            }, () => {});
            this.isUnsavedChangesTrigerred = true;
        } else {
            this.forms = [];
        }
    }
}
